import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import * as schoolRollActions from '../school-roll/actions';

export function* getStudentClassroomsRelation({ userProfileId, productId }) {
    const payload = yield call(api.getStudentClassroomsRelation, userProfileId, productId);
    if (payload.status === 200) {
        yield put(actions.getStudentClassroomsRelationSuccess(payload.data));
    } else {
        yield put(actions.getStudentClassroomsRelationFailure());
    }
}

export function* getStudentClassroomsRelationSaga() {
    yield takeLatest(actions.GET_STUDENT_CLASSROOMS_RELATION_REQUEST, getStudentClassroomsRelation);
}

export function* assignStudent({ assignedClassrooms, userProfileId, productId }) {
    const payload = yield call(api.assignStudentClassrooms, assignedClassrooms, userProfileId, productId);
    if (payload.status === 200) {
        yield put(actions.assignStudentSuccess());
        yield put(schoolRollActions.getLicenceCapSummary(productId));
    } else {
        yield put(actions.assignStudentFailure());
    }
}

export function* assignStudentSaga() {
    yield takeLatest(actions.ASSIGN_STUDENT_REQUEST, assignStudent);
}

export function* getTeacherClassroomsRelation({ userProfileId, productId }) {
    const payload = yield call(api.getTeacherClassroomsRelation, userProfileId, productId);
    if (payload.status === 200) {
        yield put(actions.getTeacherClassroomsRelationSuccess(payload.data));
    } else {
        yield put(actions.getTeacherClassroomsRelationFailure());
    }
}

export function* getTeacherClassroomsRelationSaga() {
    yield takeLatest(actions.GET_TEACHER_CLASSROOMS_RELATION_REQUEST, getTeacherClassroomsRelation);
}

export function* assignTeacher({ assignedClassrooms, userProfileId, productId }) {
    const payload = yield call(api.assignTeacherClassrooms, assignedClassrooms, userProfileId, productId);
    if (payload.status === 200) {
        yield put(actions.assignTeacherSuccess());
    } else {
        yield put(actions.assignTeacherFailure());
    }
}

export function* assignTeacherSaga() {
    yield takeLatest(actions.ASSIGN_TEACHER_REQUEST, assignTeacher);
}

export function* assignTeacherToClassroom({ teacherClassroomMapping, context }) {
    const payload = yield call(api.classroomUserRelation, teacherClassroomMapping);
    if (payload.status === 200) {
        yield put(actions.assignTeacherToClassroomSuccess(context));
    } else {
        yield put(actions.assignTeacherToClassroomFailure());
    }
}

export function* assignTeacherToClassroomSaga() {
    yield takeLatest(actions.ASSIGN_TEACHER_TO_CLASSROOM_REQUEST, assignTeacherToClassroom);
}



// WEBPACK FOOTER //
// ./app/containers/assign-user/saga.js